<template>
  <div
    class="poster"
    ref="poster"
    :style="genBgStyle()"
    v-loading="posterVisibility"
    v-on="$listeners"
    @mouseleave="isShowCodePlate = false"
  >
    <div class="mainText" :style="genTextBoxStyle()">
      <label class="input-label">
        <input
          type="text"
          class="poster-text-input"
          :maxlength="subTitle.max"
          :minlength="subTitle.min"
          v-model="subTitle.text"
          :placeholder="'请输入' + (subTitle.name || '')"
          :style="{
            border: 'none',
            textAlign: 'center',
            background: 'none',
            ...genTextStyle(subTitle),
            width: `calc(${subTitle.text.length * subTitle.fontSize}px + 1em)`,
            height: '22px',
            display: 'inline-block',
          }"
        />
      </label>
      <label class="input-label">
        <textarea
          class="poster-text-input"
          v-model="mainTitle.text"
          :style="{
            display: 'block',
            ...genTextStyle(mainTitle),
            height: '74px',
            background: 'none',
            border: 'none',
            textAlign: 'center',
            width: '100%',
          }"
          :placeholder="`请输入主标题`"
          :maxlength="mainTitle.max"
          :minlength="mainTitle.min"
          type="text"
        ></textarea>
      </label>
    </div>
    <div
      class="left_element"
      :style="genElementStyle('Left')"
      v-if="elConfig.remainPart === 1"
    >
      <img
        v-if="elementImg"
        :src="`${baseUrl}${elementImg}`"
        :style="{ height: `${elConfig.elementHeight}px` }"
        alt="poster左侧元素"
      />
    </div>
    <div
      class="right_element"
      :style="genElementStyle('Right')"
      v-if="elConfig.remainPart === 2"
    >
      <img
        ref="RImg"
        v-if="elementImg"
        :src="`${baseUrl + elementImg}`"
        :style="{ height: `${elConfig.elementHeight}px` }"
        alt="poster右侧元素"
      />
      <span class="element-mask" @click="handleMaskClick"></span>
    </div>
    <img v-if="logo.filePath" :src="logo.filePath" class="logo" />
    <div class="normalImgText">
      <img
        v-if="contentStyle.repeatBg"
        class="slice-repeat"
        :src="contentStyle.repeatBg"
        :style="repeatImgStyle"
        alt=""
      />
      <div
        class="slice-bottom-wrap"
        v-if="contentStyle.bottomBg"
        :style="bottomWrapStyle"
      >
        <img
          class="slice-bottom"
          :src="contentStyle.bottomBg"
          :style="bottomImgStyle"
          alt=""
        />
      </div>
      <label class="input-label" :style="headerStyle">
        <input
          type="text"
          class="title poster-text-input"
          v-model="contentTitle.text"
          :placeholder="'请输入' + (contentTitle.name || '')"
          :maxlength="contentTitle.max"
          :minlength="contentTitle.min"
        />
      </label>
      <div class="text">
        <div class="item" v-for="(item, index) in contentItems" :key="index">
          <span
            class="icon"
            :style="genIconStyle(contentItems[0].content)"
            v-if="contentItems[0].content.showLabelStyle"
          >
            <img :style="genIconStyle(contentItems[0].content)" :src="genIconStyle(contentItems[0].content).src" />
            <i class="num" v-if="genIconStyle(contentItems[0].content).hasNumber">{{ index + 1 }}</i>
          </span>
          <label class="input-label">
            <input
              type="text"
              class="txt"
              v-model="item.content.text"
              :maxlength="item.content.max"
              :minlength="item.content.min"
              :placeholder="`请输入宣发内容`"
            />
          </label>
        </div>
      </div>
    </div>
    <div class="code-custom">
      <label class="input-label link-name-label">
        <textarea
          type="text"
          class="link-name"
          :maxlength="codeTitle.max"
          :minlength="codeTitle.min"
          v-model="codeTitle.text"
          :placeholder="`请输入底部提示内容`"
        ></textarea>
      </label>
      <label class="input-label tip-label">
        <input
          type="text"
          class="tip"
          :style="genGuideTipStyle()"
          v-model="codeTip.text"
          :maxlength="codeTip.max"
          :minlength="codeTip.min"
          :placeholder="`请输入引导内容`"
        />
      </label>
      <div class="code" @mouseenter="isShowCodePlate = true">
        <img v-if="codeQrImg" class="img" :src="codeQrImg" />
        <span class="add-code" v-else>
          <i class="tips">添加二维码</i>
        </span>
      </div>
      <div class="upload-code" v-show="isShowCodePlate">
        <div class="mode">
          <span class="key">方式一：</span>
          <span class="value"
            ><input
              class="file-input"
              type="file"
              @change="fileChange($event)"
              accept="image/jpeg, image/jpg, image/png, image/svg"
            /><em class="qr-btn on">上传图片</em></span
          >
        </div>
        <div class="mode">
          <span class="key">方式二：</span>
          <span class="value">
            <input type="text" v-model="webUrl" class="web-url" />
            <em :class="['qr-btn', { on: webUrl.length }]" @click="generateQRCode">生成二维码</em>
          </span>
        </div>
      </div>
      <canvas class="canvas" ref="qrCanvas"></canvas>
    </div>
  </div>
</template>

<script>
import { getLabelStyleMenu, hexToRgba } from "@/assets/scripts/common.js";
import { onUpload } from "@/pages/poster/js/poster-feature";
import { iconStyleMap } from "@/pages/poster/js/poster-static";
import QRCode from "qrcode";
import { mapState } from "vuex";
export default {
  name: "AiPoster",
  props: {
    posterName: {
      required: false,
      type: String,
    },
    textStyles: {
      type: Array,
      default: () => [],
    },
    size: {
      required: false,
      type: Object,
      default: () => ({
        width: 960,
        height: 240,
      }),
    },
    bgConfig: {
      required: true,
      type: Object,
    },
    elementImg: {
      default: "./../icon/element.png",
      type: String,
    },
    textInfo: {
      required: true,
      type: Object,
    },
    elConfig: {
      required: false,
      type: Object,
      default: () => ({
        elementWidth: 480,
        elementHeight: 240,
        offsetX: 0,
        remainPart: 0,
      }),
    },
    // 海报文字模块
    posterTextMaps: {
      type: Array,
      required: true,
    },
    contentStyle: {
      type: Object,
      required: true,
      default: () => ({
        bottomBg: "",
        filePath: "",
        repeatBg: "",
      }),
    },
    logo: {
      type: Object,
      default: () => ({
        filePath: "",
        id: 0,
        logoName: "",
      }),
    },
  },
  data() {
    return {
      posterVisibility: false,
      webUrl: "",
      isShowCodePlate: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
    };
  },
  computed: {
    // 副标题
    subTitle() {
      const textMap = this.posterTextMaps.find(item => item.blockName === "mainText");
      return textMap.editOptions.subtitle;
    },
    // 主标题
    mainTitle() {
      const textMap = this.posterTextMaps.find(item => item.blockName === "mainText");
      return textMap.editOptions.title;
    },
    // contentTitle
    contentTitle() {
      const contentText = this.posterTextMaps.find(item => item.blockName === "normalImgText");
      return contentText.editOptions.floorName;
    },
    // contentText
    contentItems() {
      const contentText = this.posterTextMaps.find(item => item.blockName === "normalImgText");
      return contentText.editOptions.items;
    },
    // codeTitle
    codeTitle() {
      const codeText = this.posterTextMaps.find(item => item.blockName === "qrCode");
      return codeText.editOptions.floorName;
    },
    // codeTip
    codeTip() {
      const codeText = this.posterTextMaps.find(item => item.blockName === "qrCode");
      return codeText.editOptions.blockContent.tip;
    },
    // codeQrImg
    codeQrImg() {
      const codeText = this.posterTextMaps.find(item => item.blockName === "qrCode");
      return codeText.editOptions.blockContent.qrImg.src;
    },
    posterImg() {
      return {
        bgConfig: this.bgConfig,
        elementImg: this.elementImg,
      };
    },
    //
    themeColor() {
      const { tagBgColor } = this.bgConfig;
      let themeColor = tagBgColor || "#D6DBE0";
      themeColor = themeColor.includes(",") ? themeColor : `${themeColor}, ${themeColor}`;
      return themeColor;
    },
    headerStyle() {
      return {
        backgroundImage: this.contentStyle?.filePath
          ? `url(${this.contentStyle.filePath})`
          : "none",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center top",
        backgroundSize: "335px auto",
      };
    },
    repeatImgStyle() {
      return {
        position: "absolute",
        left: "0px",
        top: "56px",
        width: "335px",
        height: "calc(100% - 78px)",
        display: "block",
        pointerEvents: "none",
        zIndex: 0,
      };
    },
    bottomWrapStyle() {
      return {
        position: "absolute",
        left: "0px",
        bottom: "0px",
        width: "335px",
        height: "26px",
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 2,
      };
    },
    bottomImgStyle() {
      return {
        position: "absolute",
        left: "0px",
        bottom: "0px",
        width: "335px",
        height: "auto",
        display: "block",
      };
    },
  },
  watch: {
    posterImg: {
      handler(newImg) {
        this.posterVisibility = true;
        this.imgLoading(newImg);
      },
    },
  },
  methods: {
    imgLoading(newImg) {
      Promise.all([this.getImg(newImg.bgConfig.src), this.getImg(newImg.elementImg)]).then(valueArr => {
        if (valueArr[0] && valueArr[1]) {
          this.posterVisibility = false;
          this.$emit("loaded");
        }
      });
    },
    getImg(imgUrl) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () => {
          resolve(true);
        };
        img.onerror = () => {
          reject(false);
        };
        img.src = `${this.baseUrl}${imgUrl}`;
      });
    },
    genBgStyle() {
      const colorArr = this.themeColor.split(",");
      return {
        width: `${this.size.width}px`,
        backgroundImage: `linear-gradient(to bottom, ${hexToRgba(colorArr[0], 0.13)} 400px, ${colorArr[0]} 500px, ${colorArr[1]} 100%), url('//bar.xkw.com${this.bgConfig.src}')`,
      };
    },
    genElementStyle(type) {
      let styleObj = {
        width: `${this.elConfig.elementWidth}px`,
        height: `${this.elConfig.elementHeight}px`,
      };
      styleObj[`margin${type}`] = `${-this.elConfig.offsetX}px`;
      styleObj.marginBottom = `${this.elConfig.offsetY}px`;
      styleObj.marginLeft = "auto";
      return styleObj;
    },
    genTextBoxStyle() {
      const { textPositionX, textPositionY, textAlignType } = this.textInfo;
      return {
        marginTop: textPositionY + "px",
        marginLeft: textPositionX + "px",
        marginRight: textPositionX + "px",
        textAlign: textAlignType + "" === "0" ? "center" : "left",
        textShadow: "0px 4px 10px rgba(48, 48, 48, 0.30)",
      };
    },
    genTextStyle(textItem) {
      let styleObj = {
        color: textItem.fontColor,
        marginTop: textItem.marginTop + "px",
        fontSize: textItem.fontSize + "px",
        fontFamily: textItem.fontFamily,
        lineHeight: textItem.lineHeight + "px",
        textShadow: "0px 2px 5px rgba(48, 48, 48, 0.30)",
      };
      const labelStyle = this.getStyleFromlabelStyleMap(textItem.labelStyle);
      if (textItem.labelStyle && textItem.showLabelStyle) {
        Object.assign(styleObj, {
          display: "inline-block",
          lineHeight: "1.3em",
          padding: "0 0.5em .1em",
          ...labelStyle,
        });
      }
      return styleObj;
    },
    // 根据labelStyleId获取样式
    getStyleFromlabelStyleMap(labelStyleId) {
      if (!labelStyleId) return {};
      const { tagBgColor } = this.bgConfig;
      const labelStyleMap = getLabelStyleMenu(tagBgColor || "");
      return labelStyleMap[labelStyleId]?.style || {};
    },
    // 生成底部提示文本样式
    genGuideTipStyle() {
      const { tagBgColor } = this.bgConfig;
      let themeColor = tagBgColor || "#D6DBE0";
      themeColor = themeColor.includes(",") ? themeColor : `${themeColor}, ${themeColor}`;
      return {
        background: `linear-gradient(90deg, ${themeColor} 1.27%, rgba(255, 170, 7, 0) 100%)`,
      };
    },
    // 内容区的小icon样式
    genIconStyle(styleMap) {
      if (!styleMap.labelStyle || !styleMap.showLabelStyle) return {};
      return iconStyleMap[styleMap.labelStyle]?.style || {};
    },
    // 生成二维码
    generateQRCode() {
      if (!this.webUrl) {
        this.$message.error("请输入网址");
        return;
      }
      const canvas = this.$refs.qrCanvas;
      QRCode.toCanvas(canvas, this.webUrl, async error => {
        if (error) console.error(error);
        this.changeTextValue(canvas.toDataURL("image/png", 1));
      });
    },
    fileChange(e) {
      const file = e.target.files;
      if (!file.length) return false;
      if (file[0].size / 1024 > 200) {
        return this.$message.warning("图片不可超过200KB，请重新上传");
      }
      for (const i in [...Array(file.length).keys()]) {
        const reader = new FileReader();
        reader.readAsDataURL(file[i]);
        reader.onloadend = () => {
          this.changeTextValue(reader.result);
        };
      }
    },
    // 修改changeQRCode
    async changeTextValue(base64File) {
      const imgUrl = await onUpload(base64File);
      this.$emit("changeQRCode", {
        data: this.posterTextMaps[2].editOptions.blockContent.qrImg,
        params: {
          ...this.posterTextMaps[2].editOptions.blockContent.qrImg,
          src: imgUrl,
        },
      });
    },
    handleMaskClick() {
      this.$emit("maskClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.poster {
  position: relative;
  padding: 1px 0 1px;
  background: no-repeat center center;
  background-size: cover;
  height: 100%;
  z-index: 11;
  // overflow: hidden;
  .poster__element {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
  }
  .left_element,
  .right_element {
    position: relative;
    height: 100%;
    overflow: hidden;
    z-index: -1;
    margin-top: -20px;
    img {
      position: absolute;
      height: auto;
      bottom: 0;
    }
    .element-mask {
      position: absolute;
      top: 20px;
      right: 18px;
      opacity: 0;
      width: 300px;
      bottom: 30px;
      z-index: 1;
      cursor: pointer;
      border-radius: 8px;
      border: 2px dashed rgba(255, 137, 94, 0.8);
      background: rgba(255, 137, 94, 0.2);
    }
    &:hover {
      .element-mask {
        opacity: 1;
      }
    }
  }
  .left_element {
    img {
      left: 0;
    }
  }
  .right_element {
    img {
      right: -20px;
    }
  }
  .logo {
    position: absolute;
    top: 0;
    left: 0;
    height: 36px;
  }
  .normalImgText {
    position: relative;
    display: block;
    padding: 60px 0 26px;
    z-index: 11;
    width: 335px;
    margin: 0 auto 18px;
    overflow: hidden;
    .content-bg {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100%;
    }
    > .input-label {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      height: 60px;
      z-index: 3;
      .title {
        position: relative;
        margin: 0 auto;
        display: block;
        background: none;
        height: 45px;
        border: none;
        line-height: 45px;
        font-size: 19px;
        font-weight: 700;
        text-align: center;
        color: #fff;
        text-shadow: 0px 2px 5px rgba(48, 48, 48, 0.3);
      }
    }

    .text {
      position: relative;
      font-family: "阿里巴巴普惠体 REGULAR";
      z-index: 1;
      display: flex;
      margin: 0 auto;
      padding: 2px 28px 0;
      flex-wrap: wrap;
      height: calc(100% - 50px);
      flex-direction: column;
      justify-content: center;
      align-content: center;
      gap: 12px;
      .item {
        display: flex;
        align-items: center;
        justify-content: start;
        height: 100%;
        gap: 5px;
        color: #333;
        line-height: 24px;
      }
      .icon {
        position: relative;
        .num {
          position: absolute;
          left: 50%;
          top: 50%;
          color: #fff;
          transform: translate(-50%, -50%);
        }
      }
      .txt {
        background: none;
        display: block;
        border: none;
        outline: none;
        text-align: left;
        color: #333;
        width: 194px;
        height: 24px;
        &:focus {
          outline: 1px dotted #666;
          background: none;
        }
      }
      .tips {
        color: #b6b8bb;
        font-family: "阿里巴巴普惠体 REGULAR";
      }
    }
    textarea {
      resize: none;
    }
  }
  .code-custom {
    position: relative;
    width: 335px;
    margin: 0 auto 18px;
    height: 87px;
    .input-label {
      position: absolute;
      width: 194px;
      left: 14px;
      &.link-name-label {
        bottom: 34px;
      }
      &.tip-label {
        bottom: 0;
      }
    }
    .link-name {
      width: 194px;
      display: block;
      color: #fff;
      text-shadow: 0px 4px 10px rgba(48, 48, 48, 0.3);
      font-size: 15px;
      line-height: 21px;
      font-style: normal;
      font-weight: 400;
      white-space: break-spaces;
      word-wrap: break-word;
      font-family: "阿里巴巴普惠体 REGULAR";
      background: none;
      outline: none;
      border: none;
      resize: none;
      &:focus {
        outline: 1px dotted #fff;
        background: none;
      }
    }
    .tip {
      padding-left: 7px;
      display: block;
      width: 194px;
      height: 24px;
      border-radius: 20px;
      background: linear-gradient(90deg, #ffaa07 1.27%, rgba(255, 170, 7, 0) 100%);
      color: #fff;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 3.9px;
      font-family: "阿里巴巴普惠体 REGULAR";
      background: none;
      outline: none;
      border: none;
      &:focus {
        outline: 1px dotted #fff;
      }
      .direction {
        display: inline-block;
        width: 28px;
        height: auto;
      }
    }
    .code {
      position: absolute;
      width: 87px;
      height: 87px;
      bottom: 0;
      right: 0;
      border-radius: 10px;
      background: #fff;
      img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
      .add-code {
        display: block;
        height: 100%;
        width: 100%;
        &:before {
          content: "";
          position: absolute;
          top: 16px;
          left: 28px;
          width: 34px;
          height: 34px;
          background: url(./../icon/code.png) no-repeat center center;
          background-size: 100% 100%;
        }
        .tips {
          position: absolute;
          text-align: center;
          font-size: 14px;
          top: 58px;
          line-height: 16px;
          width: 100%;
          color: #624aff;
          font-style: normal;
        }
      }
    }
    .upload-code {
      position: absolute;
      width: 382px;
      bottom: 2px;
      left: 105%;
      padding: 20px;
      border-radius: 8px;
      border: 1px solid rgba(148, 131, 255, 0.3);
      background: #242931;
      z-index: 100;
      .mode {
        display: flex;
        color: rgba(255, 255, 255, 0.6);
        line-height: 38px;
        .value {
          position: relative;
          display: flex;
          gap: 10px;
          .file-input {
            opacity: 0;
            top: -24px;
            left: 0;
            position: absolute;
            width: 100%;
            height: 200px;
            cursor: pointer;
          }
          .web-url {
            height: 38px;
            width: 180px;
            padding: 0 12px;
            border-radius: 4px;
            border: 1px solid rgba(148, 131, 255, 0.3);
            background: #303742;
            color: #fff;
          }
          .qr-btn {
            color: rgba(255, 255, 255, 0.6);
            width: 85px;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            cursor: pointer;
            text-decoration: underline;
            &.on {
              color: #fff;
            }
          }
        }
      }
    }
  }
  .text_box,
  .poster-content {
    .poster-text-input {
      display: block;
      width: 100%;
      background: transparent;
      border: none;
      outline: none;
      color: #fff;
      text-align: center;
      resize: none;
      overflow: hidden;
      &:focus {
        outline: 1px dotted #fff;
        cursor: text;
        background: none;
      }
    }
  }
  .canvas {
    position: absolute;
    width: 87px;
    height: 87px;
    opacity: 0;
  }
  .input-label {
    position: relative;
    display: block;
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #ff895e66;
      z-index: 1;
      cursor: pointer;
    }
  }
  &:hover {
    .input-label {
      &:before {
        content: "";
      }
      &:focus-within {
        &:before {
          display: none;
        }
      }
    }
  }
}
</style>
